import React, {useState, useContext, useReducer} from 'react';

// import { pageUrl } from '@utils/product';
import {reducer} from '@reducers/wishlist/list';

const WishlistContext = React.createContext();
export const WishlistProvider = ({children}) => {
	const [breadcrumbs, setBreadcrumbs] = useState([]);
	const [state] = useReducer(reducer, {
		productsData: [],
		loading: true,
	});
	return (
		<WishlistContext.Provider
			value={{
				productsData: state.productsData,
				breadcrumbs,
				loading: state.loading,
				setBreadcrumbs,
			}}
		>
			{children}
		</WishlistContext.Provider>
	);
};

export function useWishlist() {
	const context = useContext(WishlistContext);
	if (context === undefined) {
		throw new Error('useWishlist must be used within a WishlistProvider');
	}
	return context;
}
